import { Div2Floor } from "../utils/Div2Floor";
import { enumElementDrawStates } from "../constants";
import { QButton } from "./QButton";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { Globals } from "./Globals";

export class QZoomButton extends QButton {
  constructor() {
    super();
    this.fZoomPlus = true;
    this.fSmallButton = false;
  }

  InitZoomButton(zoomPlus) {
    this.fZoomPlus = zoomPlus;
  }

  SetSizing(smallButton) {
    this.fSmallButton = smallButton;
  }

  DoRenderContent(drawBuffer) {
    var strokeColor = Globals._themeMode.text.body; // TODO replace hardcoded ref w ui color obj method
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Disabled:
        strokeColor = "#777777";
        break;
    }

    var ctx = drawBuffer.getContext("2d");
    ctx.strokeStyle = strokeColor;
    ctx.lineCap = "square";
    var thickness = 2;
    var lLen = 8;
    if (this.fSmallButton) {
      lLen = 6;
      thickness = 1;
    }

    ctx.lineWidth = thickness;

    var w = this.GetWidth();
    var h = this.GetHeight();

    var sx = this.fHorzOffset + Div2Floor(w) - Div2Floor(lLen) + ThicknessAdjuster(thickness);
    var sy = this.fVertOffset + Div2Floor(h) + ThicknessAdjuster(thickness);

    var ex = sx + lLen;
    var ey = sy;

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();

    if (this.fZoomPlus) {
      sx = this.fHorzOffset + Div2Floor(w) + ThicknessAdjuster(thickness);
      sy = this.fVertOffset + Div2Floor(h) - Div2Floor(lLen) + ThicknessAdjuster(thickness);

      ex = sx;
      ey = sy + lLen;
    }

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();
  }
}
